import {NavEntry} from './types'

export default function getNavItemUrl({url, external}: NavEntry, pathPrefix: string): string {
  return url.startsWith('#') || external ? url : `${pathPrefix}${url}`
}
